import React from 'react';
import {Form} from '../../../components/form/Form';
import {useFormSubmit} from '../../../controllers/useSubmitForm';

export const ChannelInputForm = props => {
  const {
    route: {params},
  } = props;
  const {row} = params;
  let {onSubmit} = useFormSubmit({
    uri: '/channels',
    eventSourceId: 'channelstable',
    ...props,
  });
  return (
    <Form
      api={`/channels/${row?._id}`}
      fields={{
        name: 1,
        api: 1,
        view: 1,
      }}
      onSubmit={onSubmit}
      header={{title: 'Add Channels'}}
      submitAction={'Save'}
      layoutFields={[
        {
          placeholder: 'Name',
          field: 'name',
          type: 'text',
        },
      ]}
      {...props}
    />
  );
};

export const EditChannelInputForm = props => {
  return (
    <ChannelInputForm
      header={{title: 'Edit Channels'}}
      mode="edit"
      {...props}
    />
  );
};
